module.exports = __webpack_public_path__ + "img/icon-cancer.10a04634.svg";